// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qS6PwdwfZ2de0p {
  z-index: 100;
  right: 36px;
  bottom: 16px;
  left: auto;
  width: 44px;
  height: 44px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `qS6PwdwfZ2de0p`
};
export default ___CSS_LOADER_EXPORT___;
